<div class="offre-background">
  <img src="assets/wavehome.png" alt="Décor wavehome" class="decor-wavehome" />
  <img src="assets/wavehome2.png" alt="Décor wavehome2" class="decor-wavehome2" />
  <img src="assets/wavehomemobile.png" alt="Décor mobile" class="decor-mobile" />
</div>

<div class="offre-content">
  <div class="offre-title-group">
    <h1 class="offre-title">Votre établissement, vos objectifs</h1>
    <p class="offre-subtitle">
      Un tarif simple, annuel ou trimestriel sans surprise.<br />
      Une solution évolutive qui s’adapte à votre réalité du terrain.
    </p>
  </div>
</div>

<div class="offre-cards">
  <!-- =========================
       Formule Essentielle
       ========================= -->
  <details
    class="offre-card"
    [attr.open]="!isMobile ? '' : null"
    [attr.disabled]="!isMobile ? true : null"
    [class.static]="!isMobile"
    (toggle)="forceOpenOnDesktop($event)"
  >
    <summary
      class="offre-card-header"
      [attr.tabindex]="!isMobile ? -1 : 0"
      [attr.aria-disabled]="!isMobile ? 'true' : null"
      role="button"
      [attr.aria-expanded]="isMobile ? true : true"
    >
      <img src="assets/stars.png" alt="Icône Essentielle" />
      <h3>Formule Essentielle</h3>
    </summary>

    <div class="offre-card-content">
      <ul>
        <li>Application Qaryos</li>
        <li>8 QR Codes à générer et à imprimer</li>
        <li>1 Rondier</li>
        <li>4 Rondes</li>
        <li>3 Tâches</li>
        <li>Support de mise en place de la solution</li>
      </ul>
      <button
        class="offre-btn"
        (click)="openPopup('Formule Essentielle'); $event.stopPropagation()"
      >
        Obtenir mon offre
      </button>
    </div>
  </details>

  <!-- =========================
       Formule Avancée
       ========================= -->
  <details
    class="offre-card"
    [attr.open]="!isMobile ? '' : null"
    [attr.disabled]="!isMobile ? true : null"
    [class.static]="!isMobile"
    (toggle)="forceOpenOnDesktop($event)"
  >
    <summary
      class="offre-card-header"
      [attr.tabindex]="!isMobile ? -1 : 0"
      [attr.aria-disabled]="!isMobile ? 'true' : null"
      role="button"
      [attr.aria-expanded]="isMobile ? true : true"
    >
      <img src="assets/flamme.png" alt="Icône Avancée" />
      <h3>Formule Avancée</h3>
    </summary>

    <div class="offre-card-content">
      <ul>
        <li>14 QR Codes sur support</li>
        <li>5 Rondiers</li>
        <li>8 Rondes</li>
        <li>8 Tâches</li>
        <li><strong>Smartphone Android et Qaryos app installée</strong></li>
        <li><strong>Accès Dashboard</strong></li>
        <li><strong>Création des comptes</strong></li>
      </ul>
      <button class="offre-btn" (click)="openPopup('Formule Avancée'); $event.stopPropagation()">
        Obtenir mon offre
      </button>
    </div>
  </details>

  <!-- =========================
       Formule Sérénité
       ========================= -->
  <details
    class="offre-card"
    [attr.open]="!isMobile ? '' : null"
    [attr.disabled]="!isMobile ? true : null"
    [class.static]="!isMobile"
    (toggle)="forceOpenOnDesktop($event)"
  >
    <summary
      class="offre-card-header"
      [attr.tabindex]="!isMobile ? -1 : 0"
      [attr.aria-disabled]="!isMobile ? 'true' : null"
      role="button"
      [attr.aria-expanded]="isMobile ? true : true"
    >
      <img src="assets/sutecase.png" alt="Icône Sérénité" />
      <h3>Formule Sérénité</h3>
    </summary>

    <div class="offre-card-content">
      <ul>
        <li>25 QR Codes sur support</li>
        <li>8 Rondiers</li>
        <li>14 Rondes</li>
        <li>14 Tâches</li>
        <li><strong>Smartphone Android et Qaryos app installée</strong></li>
        <li><strong>Accès Dashboard</strong></li>
        <li><strong>Création des comptes</strong></li>
        <li>
          <strong>Étude sur plan d'un circuit de rondes optimal par un professionnel</strong>
        </li>
      </ul>
      <button class="offre-btn" (click)="openPopup('Formule Sérénité'); $event.stopPropagation()">
        Obtenir mon offre
      </button>
    </div>
  </details>

  <!-- =========================
       POPUP FORMULAIRE
       (fermeture au clic en dehors)
       ========================= -->
  <div class="popup-backdrop" *ngIf="showPopup" (click)="closePopup()">
    <div class="popup-form" (click)="$event.stopPropagation()" aria-modal="true" role="dialog">
      <form (submit)="sendForm($event)">
        <h2>
          Demander l’offre <span>{{ selectedOffreName }}</span>
        </h2>

        <label>
          Nom <span class="star">*</span> :
          <input type="text" name="name" [(ngModel)]="contactForm.name" required />
        </label>

        <label>
          Nom de l'entreprise <span class="star">*</span> :
          <input type="text" name="company" [(ngModel)]="contactForm.company" required />
        </label>

        <label>
          Email <span class="star">*</span> :
          <input type="email" name="email" [(ngModel)]="contactForm.email" required />
        </label>

        <label>
          Offre choisie :
          <input type="text" name="offre" [value]="selectedOffreName" readonly />
        </label>

        <label>
          Message <span class="star">*</span> :
          <textarea name="message" [(ngModel)]="contactForm.message" required></textarea>
        </label>

        <div class="popup-actions">
          <button type="submit" class="btn-main" [disabled]="envoiEnCours">
            {{ envoiEnCours ? 'Envoi...' : 'Envoyer' }}
          </button>
          <button type="button" (click)="closePopup()" class="btn-cancel">Annuler</button>
        </div>

        <div class="form-required-info"><span class="star">*</span> Champs obligatoires</div>

        <!-- Bandeaux succès / erreur -->
        <div *ngIf="successMessage" class="success-message">{{ successMessage }}</div>
        <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      </form>
    </div>
  </div>
</div>

<p class="offre-asterisk"></p>
